import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { countriesReducer } from './lists/countries/slice';
import { layoutReducer } from './layout/slice';
import { authReducer } from './auth/slice';
import { expertisesReducer } from './lists/expertises/slice';
import { languagesReducer } from './lists/languages/slice';
import { emailTemplatesReducer } from './lists/emailTemplates/slice';
import { mediumsReducer } from './lists/mediums/slice';
import { availableForAppearancesInReducer } from './lists/availableForAppearancesIn/slice';
import { currentGuestReducer } from './currentGuest/slice';
import { notificationsReducer } from './notifications/slice';
import { createGuestReducer } from './createGuest/slice';
import { createQuestionsReducer } from './questions/slice';
import { subscriptionPlansReducer } from './lists/subscriptionPlans/slice';
import { upcomingInterviewsReducer } from './lists/upcomingInterview/slice';

export const store = configureStore({
  reducer: {
    layout: layoutReducer,
    auth: authReducer,
    createGuest: createGuestReducer,
    currentGuest: currentGuestReducer,
    // would be better to create LIST reducer and move all list in there
    countries: countriesReducer,
    expertises: expertisesReducer,
	languages: languagesReducer,
    emailTemplates: emailTemplatesReducer,
    mediums: mediumsReducer,
    questions: createQuestionsReducer,
    availableForAppearancesIn: availableForAppearancesInReducer,
    notifications: notificationsReducer,
    subscriptionPlans: subscriptionPlansReducer,
    upcomingInterviews: upcomingInterviewsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
